import { keyframes } from "@mui/material/styles";

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(24px); }
  to { opacity: 1; transform: none; }
`;

// Smooth entrance; disabled for users who prefer reduced motion
export const fadeUpSx = (delay = 0) => ({
  animation: `${fadeUp} 0.9s cubic-bezier(0.2, 0.7, 0.2, 1) ${delay}s both`,
  "@media (prefers-reduced-motion: reduce)": { animation: "none" },
});
